import React from 'react'
import type { ReactNode } from 'react'

import styles from './SpTitle.module.css'

type Props = {
  children: ReactNode
  dataDgId?: string
}

export const SpTitle = ({ children, dataDgId }: Props) => (
  <h1 className={styles.title} data-dg-id={dataDgId}>
    {children}
  </h1>
)
